module.exports = __webpack_public_path__ + "static/media/site-transparency.98f8c351.png";